import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const createSalesOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/sales-orders',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/sales-orders' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>' \\
--data-raw '{
    "number": "SO-TEST-001",
    "status": "Estimate",
    "type": "Standard",
    "customer": { "id": 27 },
    "salesperson": { "id": 1 },
    "dateCreated": "2026-04-27T08:00:00.000-06",
    "dateScheduled": "2026-05-15T08:00:00.000-06",
    "dateExpired": "2026-05-27T08:00:00.000-06",
    "vendorPoNumber": "VEND-PO-001",
    "customerPoNumber": "CUST-PO-001",
    "customerContact": "John Doe",
    "note": "Test SO note - all fields",
    "url": "https://example.com/order",
    "email": "john.doe@example.com",
    "phone": "801-555-1234",
    "carrier": {
        "id": 4,
        "service": { "id": 8 }
    },
    "fobPointName": "Origin",
    "paymentTerms": { "id": 1 },
    "shipTerms": "Prepaid & Billed",
    "locationGroup": { "id": 5 },
    "class": { "id": 1 },
    "currency": {
        "id": 1,
        "rate": "1"
    },
    "shipToAddress": {
        "name": "West Bikes",
        "street": "100 Cycling Ave",
        "city": "Salt Lake City",
        "state": "UT",
        "postalCode": "84111",
        "country": "UNITED STATES"
    },
    "billToAddress": {
        "name": "West Bikes",
        "street": "100 Cycling Ave",
        "city": "Salt Lake City",
        "state": "UT",
        "postalCode": "84111",
        "country": "UNITED STATES"
    },
    "soItems": [
        {
            "product": { "id": 25 },
            "type": { "name": "Sale" },
            "lineNumber": 1,
            "quantity": "3",
            "unitPrice": "299.99",
            "dateScheduled": "2026-05-15T08:00:00.000-06",
            "revision": "A",
            "note": "Item note line 1",
            "customFields": []
        },
        {
            "product": { "id": 26 },
            "type": { "name": "Sale" },
            "lineNumber": 2,
            "quantity": "1",
            "unitPrice": "149.99",
            "dateScheduled": "2026-05-20T08:00:00.000-06",
            "revision": "B",
            "note": "Item note line 2",
            "customFields": []
        },
        {
            "product": { "description": "Custom freight charge" },
            "type": { "name": "Misc. Sale" },
            "lineNumber": 3,
            "quantity": "1",
            "unitPrice": "25.00",
            "customFields": []
        },
        {
            "product": { "description": "Damaged on arrival" },
            "type": { "name": "Misc. Credit" },
            "lineNumber": 4,
            "quantity": "1",
            "unitPrice": "10.00",
            "customFields": []
        },
        {
            "type": { "name": "Subtotal" },
            "product": { "description": "Subtotal" },
            "lineNumber": 5,
            "customFields": []
        },
        {
            "type": { "name": "Discount Percentage" },
            "product": { "id": 1 },
            "lineNumber": 6,
            "customFields": []
        },
        {
            "type": { "name": "Discount Amount" },
            "product": { "name": "Loyalty Discount" },
            "unitPrice": "15.00",
            "lineNumber": 7,
            "customFields": []
        },
        {
            "type": { "name": "Assoc. Price" },
            "product": { "description": "Restocking Fee" },
            "unitPrice": "12.50",
            "lineNumber": 8,
            "customFields": []
        },
        {
            "type": { "name": "Shipping" },
            "unitPrice": "8.99",
            "lineNumber": 9,
            "customFields": []
        },
        {
            "type": { "name": "Tax" },
            "taxRate": { "id": 5 },
            "lineNumber": 10,
            "customFields": []
        },
        {
            "type": { "name": "Note" },
            "product": { "description": "Customer requested gift wrapping." },
            "lineNumber": 11,
            "customFields": []
        },
        {
            "type": { "name": "Drop Ship" },
            "product": { "id": 30 },
            "lineNumber": 12,
            "quantity": "2",
            "customFields": []
        },
        {
            "type": { "name": "Kit" },
            "product": { "id": 40 },
            "lineNumber": 13,
            "quantity": "1",
            "customFields": []
        },
        {
            "type": { "name": "Kit" },
            "product": { "id": 41 },
            "lineNumber": 14,
            "quantity": "1",
            "kitItems": [
                {
                    "type": { "name": "Sale" },
                    "product": { "id": 51 },
                    "lineNumber": 15,
                    "quantity": "2",
                    "customFields": []
                },
                {
                    "type": { "name": "Sale" },
                    "product": { "id": 52 },
                    "lineNumber": 16,
                    "quantity": "1",
                    "customFields": []
                }
            ],
            "customFields": []
        }
    ],
    "customFields": []
}'
`,
};

const createSalesOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 82,
        'number': 'SO-TEST-001',
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'fobPointName': 'Origin',
        'paymentTerms': {
            'id': 1,
            'name': 'COD'
        },
        'customer': {
            'id': 27,
            'name': 'Magic Mountain Biking'
        },
        'vendorPoNumber': 'VEND-PO-001',
        'customerPoNumber': 'CUST-PO-001',
        'customerContact': 'John Doe',
        'salesperson': {
            'id': 1,
            'name': 'admin'
        },
        'deliverTo': 'West Bikes',
        'revisionNumber': 1,
        'lastModified': {
            'username': '',
            'dateLastModified': '2026-04-27T14:56:07.292+00:00'
        },
        'dateCreated': '2026-04-27T14:00:00.000+00:00',
        'dateScheduled': '2026-05-15T14:00:00.000+00:00',
        'dateExpired': '2026-05-27T14:00:00.000+00:00',
        'totalTax': '0',
        'totalPrice': '1049.96',
        'mcTotalTax': '0',
        'mcTotalPrice': '1049.96',
        'totalIncludesTax': false,
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'note': 'Test SO note - all fields',
        'url': 'https://example.com/order',
        'currency': {
            'id': 1,
            'name': 'US Dollar',
            'code': 'USD',
            'rate': '1',
            'homeCurrency': true
        },
        'email': 'john.doe@example.com',
        'phone': '801-555-1234',
        'shipToAddress': {
            'name': 'West Bikes',
            'street': '100 Cycling Ave',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84111',
            'country': 'UNITED STATES'
        },
        'billToAddress': {
            'name': 'West Bikes',
            'street': '100 Cycling Ave',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84111',
            'country': 'UNITED STATES'
        },
        'status': 'Estimate',
        'class': {
            'id': 1,
            'name': 'None'
        },
        'shipTerms': 'Prepaid & Billed',
        'type': 'Standard',
        'soItems': [
            {
                'id': 176,
                'product': {
                    'id': 25,
                    'name': 'B101',
                    'description': 'Discount Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Sale'
                },
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'customerPartNumber': '',
                'unitPrice': '299.99',
                'totalTax': '0',
                'totalPrice': '899.97',
                'mcTotalTax': '0',
                'mcTotalPrice': '0',
                'dateScheduled': '2026-05-15T14:00:00.000+00:00',
                'revision': 'A',
                'note': 'Item note line 1',
                'status': 'Entered',
                'quantity': '3',
                'quantityFulfilled': '0',
                'quantityPicked': '0',
                'class': {
                    'id': 1,
                    'name': 'None'
                },
                'customFields': []
            },
            {
                'id': 177,
                'product': {
                    'id': 26,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Sale'
                },
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 2,
                'customerPartNumber': '',
                'unitPrice': '149.99',
                'totalTax': '0',
                'totalPrice': '149.99',
                'mcTotalTax': '0',
                'mcTotalPrice': '0',
                'dateScheduled': '2026-05-20T14:00:00.000+00:00',
                'revision': 'B',
                'note': 'Item note line 2',
                'status': 'Entered',
                'quantity': '1',
                'quantityFulfilled': '0',
                'quantityPicked': '0',
                'class': {
                    'id': 1,
                    'name': 'None'
                },
                'customFields': []
            }
        ],
        'customFields': [
            {
                'id': 20,
                'name': 'Custom',
                'value': '',
                'type': 'Text'
            }
        ]
    },
};

const createSalesOrderAttributes: Attribute[] = [
    {
        name: 'number',
        type: 'string',
        optional: true,
        description: 'The sales order number. Required if SO auto numbering is disabled. Setting this field requires the `SO_EDIT_SO_NUM` access right; without it, sending any non-empty number returns 403. Omit the field to let the server auto-assign the next number (when SO auto numbering is enabled).'
    },
    {
        name: 'status',
        type: 'string',
        optional: true,
        description: 'The order status. Must be Estimate, Expired, or Issued. Defaults to Estimate.'
    },
    {
        name: 'type',
        type: 'string',
        optional: true,
        description: 'The order type. Defaults to Standard.'
    },
    {
        name: 'customer',
        type: 'reference object',
        description: 'The customer on the sales order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'salesperson',
        type: 'reference object',
        optional: true,
        description: 'The Fishbowl user assigned as salesperson. Defaults to the authenticated user. Assigning a different user requires the `SO_EDIT_SALESPERSON` access right; without it, sending a `salesperson.id` that differs from the authenticated user returns 403. Sending the authenticated user\'s own id, or omitting the field, never requires the right.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'class',
        type: 'reference object',
        optional: true,
        description: 'The class category.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'carrier',
        type: 'reference object',
        optional: true,
        description: 'The shipping carrier.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'service',
                type: 'reference object',
                optional: true,
                description: 'The carrier service.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                ]
            }
        ]
    },
    {
        name: 'fobPointName',
        type: 'string',
        optional: true,
        description: 'Indicates when ownership/liability of the order transfers to the customer.'
    },
    {
        name: 'paymentTerms',
        type: 'reference object',
        optional: true,
        description: 'The terms of payment on the order. Defaults to the customer\'s payment terms. Choosing a different value requires the `SO_PAYMENT_TERMS` access right; without it, sending a `paymentTerms.id` that differs from the customer\'s `defaultPaymentTermsId` returns 403. Sending the customer\'s default id, or omitting the field, never requires the right.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'shipTerms',
        type: 'string',
        optional: true,
        description: 'The shipping terms on the order. Defaults to the customer\'s shipping terms.',
    },
    {
        name: 'customerPoNumber',
        type: 'string',
        optional: true,
        description: 'The customer purchase order number.',
    },
    {
        name: 'vendorPoNumber',
        type: 'string',
        optional: true,
        description: 'The vendor purchase order number.',
    },
    {
        name: 'customerContact',
        type: 'string',
        optional: true,
        description: 'The name of the customer contact.',
    },
    {
        name: 'dateCreated',
        type: 'date',
        optional: true,
        description: 'Timestamp of when the order was created.',
    },
    {
        name: 'dateScheduled',
        type: 'date',
        optional: true,
        description: 'Timestamp of when the order is scheduled to ship.',
    },
    {
        name: 'dateExpired',
        type: 'date',
        optional: true,
        description: 'Timestamp of when the order expires. Most relevant for orders with an Estimate status.',
    },
    {
        name: 'taxRate',
        type: 'reference object',
        optional: true,
        description: 'The tax rate on the order. When omitted, it defaults to the customer\'s default tax rate (or the system default tax rate); tax-exempt customers default to None. Set it explicitly for international orders.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'locationGroup',
        type: 'reference object',
        optional: true,
        description: 'The location group the order belongs to. Defaults to the user\'s default location group.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
        ]
    },
    {
        name: 'note',
        type: 'string',
        optional: true,
        description: 'The order\'s note field.',
    },
    {
        name: 'url',
        type: 'string',
        optional: true,
        description: 'The url link on the order.',
    },
    {
        name: 'currency',
        type: 'reference object',
        optional: true,
        description: 'The currency used on the order. The customer must be configured for this currency (or be a home-currency customer when omitted). Line prices are submitted and stored in the home currency regardless of the order currency.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'rate',
                type: 'number',
                optional: true,
                description: 'The currency exchange rate. Must be 1 (or null) for the home currency. Optional for a non-home currency: when omitted, the rate is resolved from the customer\'s configured exchange rate, falling back to the currency\'s configured rate. The request is rejected if no rate can be resolved.',
            }
        ]
    },
    {
        name: 'email',
        type: 'string',
        optional: true,
        description: 'The customer\'s email address for the order.',
    },
    {
        name: 'phone',
        type: 'string',
        optional: true,
        description: 'The customer\'s phone number for the order.',
    },
    {
        name: 'shipToAddress',
        type: 'object',
        optional: true,
        description: 'The shipping address on the order. Defaults to the customer\'s default ship-to address.',
        children: [
            {
                name: 'name',
                type: 'string',
                optional: true,
                description: 'The name on the address.',
            },
            {
                name: 'street',
                type: 'string',
                optional: true,
                description: 'The street line.',
            },
            {
                name: 'city',
                type: 'string',
                optional: true,
                description: 'The city.',
            },
            {
                name: 'state',
                type: 'string',
                optional: true,
                description: 'The state\'s abbreviation.',
            },
            {
                name: 'postalCode',
                type: 'string',
                optional: true,
                description: 'The postal code.',
            },
            {
                name: 'country',
                type: 'string',
                optional: true,
                description: 'The country\'s abbreviation.',
            }
        ]
    },
    {
        name: 'billToAddress',
        type: 'object',
        optional: true,
        description: 'The bill to address on the order. Defaults to the customer\'s billing address.',
        children: [
            {
                name: 'name',
                type: 'string',
                optional: true,
                description: 'The name on the address.',
            },
            {
                name: 'street',
                type: 'string',
                optional: true,
                description: 'The street line.',
            },
            {
                name: 'city',
                type: 'string',
                optional: true,
                description: 'The city.',
            },
            {
                name: 'state',
                type: 'string',
                optional: true,
                description: 'The state\'s abbreviation.',
            },
            {
                name: 'postalCode',
                type: 'string',
                optional: true,
                description: 'The postal code.',
            },
            {
                name: 'country',
                type: 'string',
                optional: true,
                description: 'The country\'s abbreviation.',
            }
        ]
    },
    {
        name: 'soItems',
        type: 'list',
        optional: true,
        description: 'A list of the sales order items. Items are processed in ascending `lineNumber` order regardless of their position in the array.',
        children: [
            {
                name: 'product',
                type: 'reference object',
                description: 'The product on the order item.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                ]
            },
            {
                name: 'type',
                type: 'reference object',
                optional: true,
                description: 'The sales order item type, identified by `id` or by `name`; when both are sent the `id` wins, and an `id` or `name` that matches no item type returns 400. Defaults to `Sale` when the whole reference is omitted. Supported values: `Sale`, `Drop Ship`, `Credit Return`, `Misc. Sale`, `Misc. Credit`, `Discount Percentage`, `Discount Amount`, `Subtotal`, `Assoc. Price`, `Shipping`, `Tax`, `Kit`, `Note`. When the resolved product is a kit (`Product.kitFlag = true`), any `Sale`, `Drop Ship`, or `Credit Return` type is automatically promoted to `Kit` (even if explicitly set). A `Drop Ship` item is saved with a linked Purchase Order created automatically (the part must have a default vendor or the request fails). A `Kit` item is either auto-expanded into the kit\'s configured child items (when no children are sent) or honored as a header for explicit children (see `kitItems`).',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        optional: true,
                        description: 'The item type id. Takes precedence over `name`.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        optional: true,
                        description: 'The item type name. Used when no `id` is sent.',
                    },
                ]
            },
            {
                name: 'kitItems',
                type: 'list',
                optional: true,
                description: 'The explicit child items of a `Kit` line, nested directly under the kit header (the same shape the GET endpoint returns). Provide this only on a `Kit` item. When present, the system uses the children you send as-is and skips the automatic kit expansion for that header; when omitted, the kit\'s configured default items are loaded and attached automatically. Each child accepts the same fields as a top-level `soItems` entry. A kit child may be of type `Sale`, `Drop Ship`, `Credit Return`, `Shipping`, `Discount Percentage`, `Discount Amount`, or `Tax`; any other type — including `Note`, `Subtotal` and the `Misc.` types — returns 400. All component children (`Sale`, `Drop Ship`, `Credit Return`) under one kit must share the same item type; `Shipping`, discount and tax children are exempt from that rule. A child cannot reference a product that is itself a kit (multi-level kits are not supported and return 400). Auto-expanded children are added exactly as the kit is configured. A child whose part is set to Always Manufacture carries its manufacture order items, so issuing the order creates the manufacture order: auto-expanded children do this whatever their configured item type, and an explicitly-sent child does it when it is a `Sale` line.',
                children: [
                    {
                        name: 'product',
                        type: 'reference object',
                        description: 'The product on the kit child item.',
                    },
                ]
            },
            {
                name: 'quantity',
                type: 'quantity',
                description: 'The quantity to be fulfilled. Must be greater than zero — zero or a negative value returns 400. Defaults to 1 when omitted.',
            },
            {
                name: 'unitPrice',
                type: 'money',
                optional: true,
                description: 'The unit price of the product. Defaults to the customer\'s price. Always expressed in the home currency, including on an order in a non-home currency. Setting this field on any line requires the `PriceOverride` access right (`SO_PRICE_OVERRIDE`). On a `Discount Amount` line, an override additionally requires `Override Discount Amount` (`SO_OVERRIDE_DISCOUNT_AMOUNT`). On a `Tax` line with a Flat Rate tax rate, an override additionally requires `Override Flat Tax Amount` (`SO_OVERRIDE_TAX_AMOUNT`). For both of those, `SO_PRICE_OVERRIDE` is a hard prerequisite — a user without it cannot override regardless of the more specific right. Requests that override without the required rights return 403. The sign is normalized by line type: Sale lines are stored as positive (a negative value is corrected to its absolute value) and Credit Return lines are stored as negative (a positive value is negated).',
            },
            {
                name: 'customerPartNumber',
                type: 'string',
                optional: true,
                description: 'The customer\'s part number for this line. If omitted, defaults to the value mapped in Customer Parts for the customer/product pair, or empty if no mapping exists.',
            },
            {
                name: 'lineNumber',
                type: 'integer',
                optional: true,
                description: 'The line number for the order item.',
            },
            {
                name: 'dateScheduled',
                type: 'date',
                optional: true,
                description: 'The scheduled fulfillment date.',
            },
            {
                name: 'revision',
                type: 'string',
                optional: true,
                description: 'The revision number for the order item.',
            },
            {
                name: 'note',
                type: 'string',
                optional: true,
                description: 'The note on the order item.',
            },
            {
                name: 'taxRate',
                type: 'reference object',
                optional: true,
                description: 'The tax rate applied to the line. If omitted, defaults to the order tax rate, or to None when the product\'s taxable flag is false. On US databases, the line tax rate must match the order tax rate or be None — providing a different rate returns 400.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number. Use 1 for None.',
                    },
                ]
            },
            {
                name: 'customFields',
                type: 'list',
                optional: true,
                description: 'A list of the order item\'s custom fields. Not gated by any access right; the SO custom-field access rights only apply to the order-level custom fields.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The custom field\'s unique identifier.',
                    },
                    {
                        name: 'value',
                        type: 'string',
                        description: 'The custom field\'s value.'
                    },
                ]
            },
        ]
    },
    {
        name: 'customFields',
        type: 'list',
        optional: true,
        description: 'A list of the order\'s custom fields.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The custom field\'s unique identifier.',
            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    },
];

const data: RequestDefinitionData = {
    id: 'create-sales-order',
    title: 'Create a sales order',
    description: 'Creates a sales order. The order\'s "created by" user and last-modified username are automatically set to the authenticated user. For sale items (Sale, Drop Ship, Credit Return), when the "Show Markup Cost" Sales Order option is enabled, each line\'s part cost is populated from the product\'s current part cost (same value the legacy SO item dialog shows in the cost column). For sale items whose product references a Part of type Non-Inventory, Service, or Shipping, the line\'s total cost is set automatically from the Part\'s standard cost × quantity (with UOM conversion). Inventory parts leave the line\'s total cost at zero — their cost is determined at fulfillment from the inventory cost layers. When no order `taxRate` is supplied, the order falls back to the customer\'s default tax rate (or the system default tax rate), and tax-exempt customers default to None, so taxable lines are taxed by default. Each line\'s tax rate defaults to the order tax rate (or to None when the product is non-taxable); on US databases, a line tax rate that differs from the order tax rate is rejected (must be the order rate or None). The line\'s taxableFlag is derived from the resolved tax rate (None ⇒ false, otherwise true). Order-level custom fields require the SO custom-field access right; line-level custom fields are not gated. Several pricing-related fields are gated by access rights: setting `soItems[].unitPrice` requires `SO_PRICE_OVERRIDE`, and adding any `Discount Amount`/`Discount Percentage` line also requires `SO_PRICE_OVERRIDE`. Overriding the amount of a `Discount Amount` line additionally requires `SO_OVERRIDE_DISCOUNT_AMOUNT`, and overriding the amount of a Flat-Rate `Tax` line additionally requires `SO_OVERRIDE_TAX_AMOUNT`. `SO_PRICE_OVERRIDE` is a prerequisite for both of those overrides — a user without it cannot override a discount or flat-tax amount regardless of the more specific right. Several order-level fields are also gated: setting `number` requires `SO_EDIT_SO_NUM`, setting `salesperson` to a user other than the authenticated user requires `SO_EDIT_SALESPERSON`, and setting `paymentTerms` to a value other than the customer\'s default requires `SO_PAYMENT_TERMS`. Missing rights return 403. **Kit items** can be created in two modes: (1) header-only — send a single line whose product is a kit (a `Sale`, `Drop Ship`, or `Credit Return` type is auto-promoted to `Kit`, even if explicitly set) and the kit\'s configured child items are loaded and attached automatically, with their quantities scaled by the header quantity and their prices following the kit\'s `Use Price` flag; or (2) explicit children — send the kit header with its child items nested in the header\'s `kitItems` array (the same shape the GET endpoint returns); in this mode the system uses the children you provide as-is and skips the automatic expansion. Multi-level kits (a kit whose child is itself a kit) are not supported and return 400. A kit child may be of type `Sale`, `Drop Ship`, `Credit Return`, `Shipping`, `Discount Percentage`, `Discount Amount`, or `Tax`; every other type returns 400, and all component children (`Sale`, `Drop Ship`, `Credit Return`) under one kit must share the same type. **Always Manufacture parts**: a `Sale` line whose part is flagged Always Manufacture carries its manufacture order items, so issuing the order creates the manufacture order; `Drop Ship` and `Credit Return` lines never manufacture. Kit children expanded from the kit\'s configuration do the same whatever their configured item type. **Drop Ship items** are accepted with `type.name = "Drop Ship"`. When the order is saved, a linked Purchase Order is created automatically per the SO\'s `LocationGroup` and the part\'s default vendor; if the part has no default vendor the save fails with 400. **Currency rate**: on an order in a non-home currency, an omitted `currency.rate` is resolved from the customer\'s configured exchange rate, falling back to the currency\'s configured rate; the request is rejected if no rate can be resolved. The customer must be configured for the requested currency. Line prices remain home-currency amounts on every order.',
    endpoint: {
        verb: 'POST',
        path: '/sales-orders',
        tooltip: 'Create a sales order',
    },
    attributes: createSalesOrderAttributes,
    requestObject: createSalesOrderRequest,
    responseObject: createSalesOrderResponse,
};

export default data;